import type { JSX, ReactNode, HTMLAttributes } from 'react';
import { styled } from 'styled-components';
import { TableSectionContext } from './TableSectionContext';

const StyledThead = styled.thead`
  width: 100%;
`;

export type TableHeadProps = HTMLAttributes<HTMLTableSectionElement> & {
  children?: ReactNode;
};

export const TableHead = ({ children, ...props }: TableHeadProps): JSX.Element => {
  return (
    <TableSectionContext.Provider value="head">
      <StyledThead {...props}>{children}</StyledThead>
    </TableSectionContext.Provider>
  );
};
